module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v("Povolené klíče uživatelů")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.addShown),
      callback: function($$v) {
        _vm.addShown = $$v
      },
      expression: "addShown"
    }
  }, [_c('v-card', [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('configuration.certs.addKey.title')))])], 1), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    attrs: {
      "items": _vm.items,
      "item-text": "name",
      "item-value": "_self",
      "label": _vm.$t('configuration.certs.addKey.certificate'),
      "autocomplete": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addShown = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat",
      "loading": _vm.isBusy
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.value.certificates), function(item) {
    return _c('v-list-tile', {
      key: item._self || item.name
    }, [_c('v-list-tile-content', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.remove(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 1)
  })), _vm._v(" "), (!_vm.value.certificates || _vm.value.certificates.length === 0) ? _c('div', {
    staticClass: "text-xs-center my-5"
  }, [_vm._v(_vm._s(_vm.$t('configuration.certs.noCerts')))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-505abb50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Configuration/Certificates.vue
// module id = 1075
// module chunks = 1